import { render, staticRenderFns } from "./TournamentLandingAdmin.vue?vue&type=template&id=c67d4a46&scoped=true"
import script from "./TournamentLandingAdmin.vue?vue&type=script&lang=js"
export * from "./TournamentLandingAdmin.vue?vue&type=script&lang=js"
import style0 from "./TournamentLandingAdmin.vue?vue&type=style&index=0&id=c67d4a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67d4a46",
  null
  
)

export default component.exports